module.exports = __webpack_public_path__ + "img/Icon - CONS.f7d9588e.png";